// frontend/src/components/entry/EntryErrorScreen.jsx
//
// A backend read the entry order depends on failed (`entryScreen.js`:
// CLAIM_ERROR, SETUP_ERROR, SYNC_ERROR, and the sign-in check in App.jsx).
// Fail closed: the app is not shown, the failure is named with the next step
// for its cause, and the only affordance re-runs the read.
//
// `error` is the failed request. A part the server answered as failed has
// none: the server crashed on it, which `requestFailedKey` reads as a refusal.

import { useTranslation } from 'react-i18next';
import { Button, Typography } from '@mui/material';

import EntryDialog from './EntryDialog';
import { requestFailedKey } from '../../queries/api';

export default function EntryErrorScreen({ message, error, onRetry }) {
  const { t } = useTranslation();
  return (
    <EntryDialog
      title={message}
      actions={<Button variant="contained" onClick={onRetry}>{t('entry.retry')}</Button>}
    >
      <Typography color="text.secondary">{t(requestFailedKey(error))}</Typography>
    </EntryDialog>
  );
}
